import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import BackBtn from "../../common/backBTN";

function Withdrawal({items, userData, transactionData, hasEWallet, general}){
     const [activeItem, setActiveItem] = useState(null); 
  const [activeAmount, setActiveAmount] = useState(""); 
  const [icon, setIcons] = useState(''); 
  const [selectedAccount, setSelectedAccount] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false); 
  const [showModal, setShowModal] = useState(false); 
  const [modalMessage, setModalMessage] = useState(""); 
  const [wapy, setWapy] = useState(false);
	// Enable editable account number for bk8bd and cb444 sites
	const isBk8bd = typeof window !== 'undefined' &&
		window.location &&
		typeof window.location.hostname === 'string' &&
		window.location.hostname.toLowerCase().includes('bk8bd');
    const isCb444 = typeof window !== 'undefined' &&
        window.location &&
        typeof window.location.hostname === 'string' &&
        window.location.hostname.toLowerCase().includes('cb444');
		const isRocket88 = typeof window !== 'undefined' &&
				window.location &&
				typeof window.location.hostname === 'string' &&
				window.location.hostname.toLowerCase().includes('rocket88');
		const isBeetbuzz = typeof window !== 'undefined' &&
				window.location &&
				typeof window.location.hostname === 'string' &&
				window.location.hostname.toLowerCase().includes('beetbuzz');
  
	// For bk8bd/cb444, default to the user's phone number if available
	useEffect(() => {
		if ((isBk8bd || isCb444) && userData && userData.phone && !selectedAccount) {
			setSelectedAccount(userData.phone);
		}
	}, [isBk8bd, isCb444, userData, selectedAccount]);
  // Removed unused state variable to avoid confusion
  const [numbers, setNumbers] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const remoteId = localStorage.getItem('remote_id');
  
  // Determine minimum withdrawal amount based on origin
  const getMinAmount = () => {
    if (isBeetbuzz) return 200;
    if (isRocket88) return 700;
    return 500;
  };
  const minAmount = getMinAmount();
  const amounts = ["2000", "3000", "5000", "10000", "15000", "20000", "25000", "1000", "700" ,"500", "200"].filter(amt => parseInt(amt) >= minAmount);
  const firstItem = items.find(item => item.status === "active");
	const [pgs, setPgs] = useState([]);
	const [name, setName] = useState('');
	

	useEffect(() => {
		const uniquePaymentMethods = [];
		const seenNames = new Set();
		items.forEach((item) => {
			if (item.name && !seenNames.has(item.name.toLowerCase())) {
				seenNames.add(item.name.toLowerCase());
				uniquePaymentMethods.push(item);
			}
		});
		if (Number(general?.withdrawal_status) === 0) {
			setPgs([]);
		} else {
			setPgs(uniquePaymentMethods);
		}
		
	}, [items]);

	useEffect(() => {
		setName(firstItem?.name);
	 }, [firstItem]);

	// console.log(`Selector method: ${firstItem?.name}`);
	// console.log(`Selector method XX:`, items);
	
	const [getotherContracts, setOtherContracts] = useState([]);

	// const fetchOther = async () => {
	// 	const token = localStorage.getItem('token');
	// 	if (token) {
	// 		try {
	// 			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
	// 				method: 'GET',
	// 				headers: {
	// 					'Authorization': `Bearer ${token}`,
	// 				},
	// 			});

	// 			if (response.ok) {
	// 				const data = await response.json();
	// 				setOtherContracts(data.data || []);
	// 				console.log(data.data);
				   
	// 			} else {
	// 				console.error('Failed to fetch user data');
	// 			}
	// 		} catch (error) {
	// 			console.error('Error fetching user data:', error);
	// 		}
	// 	}
	// };
	
	// useEffect(() => { 
	// 	fetchOther();
	// }, []);
 
  const handleItemClick = (id, icon, name) => {
	setActiveItem(id); 
	setIcons(icon);
	setName(name);
  };
  // Fetch other contracts
  const fetchWay = async () => {
		const token = localStorage.getItem('token');
		if (!token) return;

		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/wpay/check`, {
			method: 'GET',
			headers: {
				'Authorization': `Bearer ${token}`,
				'Accept': 'application/json',
			},
			});

			if (!response.ok) {
			console.error('Failed to fetch wpay check:', response.statusText);
			return;
			}
			const data = await response.json();
			setWapy(true); 
		} catch (error) {
			console.error('Error fetching wpay check:', error);
		}
		};
  
  useEffect(() => {
	  fetchOtherContracts();
	  if (firstItem) { 
		setActiveItem(firstItem.id); 
		setIcons(firstItem.icon);
	  }
	  console.log(firstItem);
  }, []);

  // Set default selected account when data is available
  

  const fetchOtherContracts = async () => {
	if (token) {
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			if (response.ok) {
				const data = await response.json();
				// Filter contracts where isverify is 1
				// let verifiedContracts = (data.data || []).filter(contract => contract.isverify === 1);
				// if (userData?.session_id == 1) { 
				// 	verifiedContracts.push(userData?.phone);
				// }
				// Removed unused setter call for clarity
				let numbers = [];
				if (!isRocket88 && userData?.session_id == 1 && userData?.phone) {
					numbers.push(userData?.phone);
				}
				// if (userData?.session_id == '1') {
				// 	data.push(userData?.phone);
				// }
				if(data?.data && data?.data.length > 0) {
					data.data.forEach((item) => {
						if (item.isverify) {
							numbers.push(item.contract_value);
						}
					});
				}
				setNumbers(numbers);
				if (numbers.length > 0) {
					console.log("Selected account:", numbers, numbers[0]);
					setSelectedAccount(numbers[0]);
				}
			} else {
				console.error("Failed to fetch contracts");
			}
		} catch (error) {
			console.error("Error fetching contracts:", error);
		}
	}
};

   
	
  const handleSelection = (value) => {
	setSelectedAccount(value);
	console.log(value);
  };

  const handleAmountClick = (amount) => {
	setActiveAmount(amount); 
  };
  const checkUserEligibility = async () => {
	try {
	  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/userwithdrawcheck?remote_id=${remoteId}`, {
		method: 'GET',
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': `Bearer ${token}`,
		},
	  });
  
	  const data = await response.json();
	  console.log('API response data:', data);
  
	  if (!response.ok) {
		  if (response.status === 400) {
			if (data.error.match(/Date of Birth/i)) { 
				setModalMessage(`<a href="/profile">${data.error}</a>`);
			} else {
				setModalMessage(data.error || '<a href="/turnover-record">Please complete your turnover and try again.</a>');
			}
		  setShowModal(true);
		  return false;
		} else {
		  setModalMessage(data.error || 'An error occurred.');
		  setShowModal(true);
		  return false;
		}
	  }
  
	  if (data.success) {
		// User is eligible for withdrawal
		return true;
	  } else {
		// Fallback for other cases
		setModalMessage('An unknown error occurred.');
		setShowModal(true);
		return false;
	  }
	} catch (error) {
	  return false;
	}
  };
  

  const handleSubmit = async () => {

	if (Number(general?.withdrawal_status) === 0) {
  setPgs([]);
  setModalMessage("No active payment method available for withdrawals.");
  setShowModal(true);
  return;
}

	// Check phone verification - session_id === '1' means verified
	if (userData?.session_id !== '1') {
		setModalMessage(`<a href="/profile">Please verify your mobile number first to make withdrawals.</a>`);
		setShowModal(true);
		return;
	}
	 
	if (transactionData && transactionData.length > 0) {
		for (let trns of transactionData) {
			if (trns.action == "withdraw" && trns.key === "0") {
				setModalMessage(`You already have a withdraw request pending. Please wait for it to be processed before making another withdraw request.`);
				setShowModal(true);
				return;
			}
		}
	}
	  
	if (!activeAmount) {
		setModalMessage("Amount is required.");
		setShowModal(true);
		return;
	}

	// Validate account/mobile number
	if (isBk8bd || isCb444) {
		const digitsOnly = String(selectedAccount || '').replace(/\D/g, '');
		if (digitsOnly.length !== 11) {
			setModalMessage("Please enter a valid 11-digit mobile number.");
			setShowModal(true);
			return;
		}
	} else {
		if (!selectedAccount) {
			setModalMessage("Account number is required.");
			setShowModal(true);
			return;
		}
		if (isNaN(selectedAccount)) {
			setModalMessage("Account number is required.");
			setShowModal(true);
			return;
		}
	}

  
	if (!activeItem) {
		setModalMessage("Please select your payment method.");
		setShowModal(true);
		return;
	}
  
	// Check user eligibility
	const eligible = await checkUserEligibility();
	if (!eligible) {
		return;
	}
  
	setSubmitLoading(true);
  
	const remoteId = localStorage.getItem("remote_id");
  
	const requestBody = {
		remote_id: remoteId,
		account_number: selectedAccount,
		amount: activeAmount,
		payment_id: hasEWallet ? 0 : activeItem,
		provider: hasEWallet ? name : name,
	};
  
	console.log(requestBody);
  
	try {
    let response;
    if (wapy) {
      
		response = await fetch(`${process.env.REACT_APP_API_URL}/api/payout`, {
			method: "POST",
			headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
			amount: activeAmount,
			method: name,
			account: selectedAccount,
			userName: userData?.username || "Customer",
			}),
		});
		} else {
		response = await fetch(`${process.env.REACT_APP_API_URL}/api/submit-withdraw`, {
			method: "POST",
			headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(requestBody),
		});
		}
  
	  if (!response.ok) {
		const errorData = await response.json();
		setModalMessage(errorData.error);
		setShowModal(true);
		return;
	  }
  
	  const data = await response.json();
  
	  if (data.success) {
		setModalMessage("Withdrawal successful!");
		setShowModal(true);
		navigate("/payment-request", {
		  state: {
			amount: activeAmount,
			payment_icon: icon,
		  },
		});
	  } else {
		setModalMessage(data.message);
		setShowModal(true);
	  }
	} catch (error) {
	  setModalMessage("An error occurred. Please try again.");
	  setShowModal(true);
	} finally {
	  setSubmitLoading(false);
	}
  };

	
    return(
        <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
  <div className="my-home">
    <div className="ios-version" id="v2-vc-container">
      <div className="mc-header-wrap">
        <div id="mc-header" className="mc-navbar-blue mc-voucherCenter mc-default-header am-navbar am-navbar-light">
          <BackBtn/>
          <div className="am-navbar-title">Withdrawal</div>
          <Link to={'/deposit'} className="right-wrapper">
			<div className="report-icon">
				
				<svg className="am-icon am-icon-voucher_list_b99e1f01 am-icon-md am-navbar-title"><use xlinkHref="#voucher_list_b99e1f01" /></svg>
			</div>
			<div className="cs-icon">
				<svg className="am-icon am-icon-service_c87ca62b am-icon-md am-navbar-title"><use xlinkHref="#service_c87ca62b" /></svg>
			</div>
			</Link>
        </div>
        <div className="am-whitespace am-whitespace-sm mc-whitespace" />
      </div>
      <div className="vc-scroll-container">
        <div className="vc-v2-container">
          <div className="pd-btm-20 ranndom-container">
            <div className="vc-v2-title">Withdrawal Method</div>
            <div className="min-list vc-v2-method show-more-container">
				{pgs.length === 0 && (
							<div className="no-payment-method">No widthdraw methods available.<br />Try again later.</div>
						)}
              <ul>
                {pgs.map(
								(item) =>
								item.status === "active" && (
                <li className={`change-item-animate ${item.name} recommendation ${name === item.name ? "ck" : ""}`} key={item.id} onClick={() => handleItemClick(item.id, item.icon, item.name)}>
                  {name === item.name && (
                  <svg className="am-icon am-icon-checked_0a488f7d am-icon-md deposit-list-ck"><use xlinkHref="#checked_0a488f7d" /></svg>
                  )}
                   <div className="deposit-img-new"><img 	src={`./${item.icon}`} alt="" style={{display: 'block'}} /></div>
                  <div className="desc-content">
                    <div className="desc-info">
                      <div className="vcn-list-text"><p>{item.name}</p></div>
                    </div>
                  </div>
                </li>
                )
							)}
              </ul>
            </div>
          </div>
          <div className="vc-v2-space-content vc-v2-space-content" />
          <div className>
            
            {/* react-empty: 1846 */}
            <div className="ranndom-container hide">
              <div className="vc-v2-title pay-name">ID number</div>
              <div className="vc-v2-input">
                <div className="inputCon"><input type="text" inputMode="text" className="inputBase" placeholder="Please enter your ID number" name="idNumber" defaultValue /></div>
              </div>
            </div>
            <div className="ranndom-container hide">
              <div className="vc-v2-title pay-name">Bank Account Name</div>
              <div className="vc-v2-input">
                <div className="inputCon"><input type="text" inputMode="text" className="inputBase" placeholder="Bank Account Name" name="payee" defaultValue /></div>
              </div>
            </div>
            <div className="ranndom-container hide">
              <div className="vc-v2-title pay-name">Nickname</div>
              <div className="vc-v2-input no-border">
                <div className="inputCon"><input type="text" inputMode="text" className="inputBase" placeholder="Please enter a nickname" name="nickname" /></div>
              </div>
            </div>
            {/* react-text: 1862 */}{/* /react-text */}
            <div className>
              <div id="payAmount" className="ranndom-container vc-v2-amount">
                <div className="vc-v2-title pay-amount">Withdrawal Amounts</div>
                <div className="vc-v2-input">
                  <div className="deposit-amount-con">
                    <div className="fixed-money">
                          {amounts.map((amount) => (

                                    <div key={amount} onClick={() => handleAmountClick(amount)} className={`fixed-money-item number-mc ${activeAmount === amount ? 'money-active' : ''}`}>
                          {activeAmount === amount && <svg className="am-icon am-icon-checked_0a488f7d am-icon-md deposit-list-ck"><use xlinkHref="#checked_0a488f7d" /></svg>}

                          
                          {amount}</div>
                          ))}
                     
                    </div>
                    <div>
                      <div className="inputCon false">
                        <i>৳</i><input type="text" value={activeAmount} onChange={(e) => setActiveAmount(e.target.value)} onClick={(e) => e.stopPropagation()} inputMode="decimal" maxLength={11} placeholder={`${minAmount} - 25,000`} className="inputBase" name="deposit" />
                        
                      </div>
                      <br/>
											 {(isBk8bd || isCb444) ? (
												 <>
													 <div className="inputCon false">
														 <input
															 type="text"
															 className="inputBase"
															 value={selectedAccount}
															 onChange={(e) => setSelectedAccount(e.target.value)}
															 inputMode="numeric"
															 maxLength={11}
															 placeholder="Enter account number"
															 name="accountNumber"
														 />
													 </div>
													 <div className="am-whitespace am-whitespace-sm" />
													 <div style={{fontSize: '.24rem', color: '#888'}}>
														 Note: Default shows your number. Edit it if you want to use a different number.
													 </div>
												 </>
											 ) : (
												 <div className="inputCon false">
													 <select
														 className="inputBase"
														 value={selectedAccount}
														 onChange={(e) => handleSelection(e.target.value)}
													 >
														 {numbers && numbers.length > 0 ? (
															 numbers.map((num) => (
																 <option key={num} value={num}>
																	 {num}
																 </option>
															 ))
														 ) : (
															 <option value="">Select Account Number</option>
														 )}
													 </select>
												 </div>
											 )}
                     
                    </div>
                  </div>
                </div>
                {/* react-text: 1874 */}{/* /react-text */}
              </div>
              <div className="am-flexbox am-flexbox-align-middle errors">
                <div className="am-flexbox-item">
                  <span className="hide">
                    {/* react-text: 1878 */}Handling fee{/* /react-text */}{/* react-text: 1879 */}:{/* /react-text */}
                    <i />
                  </span>
                </div>
              </div>
            

              <div className="ranndom-container hide">
                <div className="vc-v2-title pay-dc vc-v2-space">
                  <div className="am-flexbox am-flexbox-align-middle flex-con-new flex-another-pay flex-pay-showborder hide">
                    {/* react-text: 1887 */}Deposit on behalf{/* /react-text */}
                    <span>
                      {/* react-text: 1889 */}
                      {/* /react-text */}{/* react-text: 1890 */}Click to deposit for other user.{/* /react-text */}
                    </span>
                    <div className="agrg-downline-type switch-box setting_sort_right">
                      <div className="mc-switch mc-qutas-bg"><div className="checkbox" /></div>
                      <span className="agrg-downline-cname other-size">Deposit on behalf</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="vc-v2-other vc-v2-input">
                <div className="am-flexbox am-flexbox-align-middle hide flex-con flex-con-other">
                  <div className="am-flexbox-item">
                    <div className="inputCon"><input type="text" inputMode="text" maxLength={15} className="inputBase" placeholder="Please enter the user name" name="targetName" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hide"><div className="vc-v2-submit">Wallet address</div></div>
      <div  className={`vc-v2-submit ${activeAmount ? "" : "dis"}`}  onClick={handleSubmit}>
        <i className="arrow-down" />
        <div>Next</div>
      </div>
     
            {showModal && (
                  <>
              <div  onClick={() => setShowModal(false)} className="am-modal-mask" />
              <div tabIndex={-1} className="am-modal-wrap" role="dialog" aria-labelledby="rcDialogTitle0">
                <div role="document" className="am-modal am-modal-transparent" style={{width: '5.4rem', height: 'auto'}}>
                  <div className="am-modal-content">
                    <div className="am-modal-header"><div className="am-modal-title" id="rcDialogTitle0">Confirmation</div></div>
                    <div className="am-modal-body">
                      <div style={{zoom: 1, overflow: 'hidden'}}>
                        <div className="change-modal-title" dangerouslySetInnerHTML={{ __html: modalMessage }} />
                      </div>
                    </div>
                    <div className="am-modal-footer">
                      <div className="am-modal-button-group-h am-modal-button-group-normal" role="group"><Link  onClick={() => setShowModal(false)} className="am-modal-button" role="button">Cancel</Link><Link onClick={() => setShowModal(false)} className="am-modal-button" role="button">OK</Link></div>
                    </div>
                  </div>
                  <div tabIndex={0} style={{width: '0px', height: '0px', overflow: 'hidden'}}>sentinel</div>
                </div>
              </div>
            </>
              )}
    </div>
  </div>
</div>

    );

}
export default Withdrawal;